module.exports = __webpack_public_path__ + "static/media/manuel3.0f3f42d1.png";